import { useEffect, useState } from 'react'
import { apiRequest, isUserLoggedIn, showKAlert, updateNestedField } from '../helpers'
import { useDebouncedCallback } from 'use-debounce'
import { Col, Container, Form, Row } from 'react-bootstrap'
import KLayerNavigation from '../components/KLayerNavigation'
import { t } from '../locale'
import {
  BuildingFillGear,
  CreditCardFill,
  Globe2,
  InfoCircleFill,
  PersonFill,
  PersonVcardFill,
} from 'react-bootstrap-icons'

export default function StammdatenRequiredPerson() {
  const [persoenlicheOpen, setPersoenlicheOpen] = useState(false)
  const [legitOpen, setLegitOpen] = useState(false)
  const [adressenOpen, setAdressenOpen] = useState(false)
  const [kommunikationOpen, setKommunikationOpen] = useState(false)
  const [bankenOpen, setBankenOpen] = useState(false)
  const [beziehungenOpen, setBeziehungenOpen] = useState(false)

  const [form, setForm] = useState({
    client_since: false,
    client_to: false,
    anrede: false,
    academic_degree: false,
    first_name: false,
    name: false,
    short_name: false,
    noble_title: false,
    name_prefix: false,
    alternative_search_name: false,
    note: false,
    natural_person_data: {
      birth_date: false,
      birth_name: false,
      full_first_names: false,
      place_of_birth: false,
      country_of_birth: false,
      birth_registration_number: false,
      nationality: false,
    },
    national_law: {
      nationality: false,
      marital_status: false,
      eu_vat_id_country_code: false,
      federal_state: false,
      pension_insurance_no: false,
      pension_insurance_provider: false,
      eTIN: false,
      identification_number: false,
    },
    natural_person_legitimation: {
      legitimation_type: false,
      comment: false,
      pep: false,
      id_number: false,
      birth_date: false,
      nationality: false,
      place_of_birth: false,
      valid_to: false,
      issued_on: false,
      issuing_authority: false,
    },
    address: {
      valid_since: false,
      valid_to: false,
      address_suffix: false,
      zip_code: false,
      city: false,
      country: false,
      shipping_supplement: false,
      note: false,
      street: false,
    },
    communication: {
      phone: false,
      email: false,
      url: false,
    },
    bank: {
      valid_since: false,
      valid_to: false,
      country: false,
      account_number: false,
      account_holder: false,
    },
    tax_authority: {
      valid_since: false,
      valid_to: false,
      country_code: false,
      tax_number: false,
    },
    beziehung: {
      hatIst: false,
      name: false,
      addressee_type: false,
      anrede: false,
      tax_authority: {
        country_code: false,
        tax_authority_name: false,
        tax_number: false,
      },
      address: {
        type: false,
        zip_code: false,
        city: false,
        country: false,
        phone: false,
        email: false,
      },
      legal_person_info: {
        legal_form: false,
      },
      naturliche_person_info: {
        academic_degree: false,
        birth_date: false,
        federal_state: false,
        id_number: false,
      },
    },
  })

  useEffect(() => {
    getRequired()
  }, [])

  const debouncedSave = useDebouncedCallback((field: string, value: any) => {
    save(field, value)
  }, 100)

  const changeLocal = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id } = e.target
    const value = (e.target as HTMLInputElement).checked

    setForm(prev => updateNestedField(prev, id, value))
    debouncedSave(id, value)
  }

  const getRequired = async () => {
    const res = await apiRequest(
      `${process.env.REACT_APP_API_URL}/stammdaten/requiredBy?type=person`,
      'GET'
    )

    if (res.result) {
      res.result.fields.forEach((element: any) => {
        const fieldPath = element.name
        const value = element.required

        setForm(prev => {
          const newForm = { ...prev }
          const keys = fieldPath.split('.')
          let current: any = newForm

          for (let i = 0; i < keys.length - 1; i++) {
            if (!current[keys[i]]) {
              current[keys[i]] = {}
            }
            current = current[keys[i]]
          }

          current[keys[keys.length - 1]] = value

          return newForm
        })
      })
    }
  }

  const save = async (id: string, value: any) => {
    apiRequest(`${process.env.REACT_APP_API_URL}/stammdaten/required`, 'POST', {
      type: 'person',
      fields: [
        {
          name: id,
          required: value,
        },
      ],
    }).then(r => {
      if (!r.ok) showKAlert('danger', 'error')
    })
  }

  return (
    <>
      <Container>
        <Row>
          <div className='sidebar col-md-3 col-lg-2'>
            <KLayerNavigation logged={isUserLoggedIn()} />
          </div>
          <main className='col-md-9 col-lg-10 pb-5'>
            <h5>{t('personRequired')}</h5>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('mandantSeit')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id='client_since'
                  checked={form.client_since}
                  onChange={changeLocal}
                />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('mandantBis')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id={'client_to'}
                  checked={form.client_to}
                  onChange={changeLocal}
                />
              </Col>
            </Row>
            <h6 className='bg-gray-200 p-2 rounded mb-3 mt-3'>
              <BuildingFillGear />
              {t('Angaben')}
            </h6>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('anrede')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id={'anrede'}
                  checked={form.anrede}
                  onChange={changeLocal}
                />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('titelGrad')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id={'academic_degree'}
                  checked={form.academic_degree}
                  onChange={changeLocal}
                />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('firstName')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check type='checkbox' id={'first_name'} checked={true} disabled />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('name')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check type='checkbox' id={'name'} checked={true} disabled />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('nameKurz')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id={'short_name'}
                  checked={form.short_name}
                  onChange={changeLocal}
                />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('adelstitel')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id={'noble_title'}
                  checked={form.noble_title}
                  onChange={changeLocal}
                />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('namensvorsatz')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id={'name_prefix'}
                  checked={form.name_prefix}
                  onChange={changeLocal}
                />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('alternativerSuchname')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id={'alternative_search_name'}
                  checked={form.alternative_search_name}
                  onChange={changeLocal}
                />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col xs={2}>
                <label>{t('Notiz')}</label>
              </Col>
              <Col xs={2}>
                <Form.Check
                  type='checkbox'
                  id={'note'}
                  checked={form.note}
                  onChange={changeLocal}
                />
              </Col>
            </Row>

            <Row className='mt-4'>
              <h5
                className='bg-collapse text-white p-2 rounded mb-3 cursor-pointer d-flex align-items-center'
                onClick={() => setPersoenlicheOpen(!persoenlicheOpen)}
              >
                <PersonFill />
                &nbsp;{t('persönlicheDaten')}
                {<b className='ms-auto'>{persoenlicheOpen ? '▼' : '►'}</b>}
              </h5>
            </Row>

            {persoenlicheOpen && (
              <>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('dateOfBirth')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_data.birth_date'
                      checked={form.natural_person_data.birth_date}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('geburtsname')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_data.birth_name'
                      checked={form.natural_person_data.birth_name}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('vollständigeVornamen')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_data.full_first_names'
                      checked={form.natural_person_data.full_first_names}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('geburtsort')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_data.place_of_birth'
                      checked={form.natural_person_data.place_of_birth}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('geburtsland')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_data.country_of_birth'
                      checked={form.natural_person_data.country_of_birth}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('staatsangehörigkeit')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_data.nationality'
                      checked={form.natural_person_data.nationality}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row className='mt-2'>
              <h5
                className='bg-collapse text-white p-2 rounded mb-3 cursor-pointer d-flex align-items-center'
                onClick={() => setLegitOpen(!legitOpen)}
              >
                <PersonVcardFill />
                &nbsp;{t('Legitimation/Identifizierung')}
                {<b className='ms-auto'>{legitOpen ? '▼' : '►'}</b>}
              </h5>
            </Row>
            {legitOpen && (
              <>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('legitimationsart')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_legitimation.legitimation_type'
                      checked={form.natural_person_legitimation.legitimation_type}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('kommentar')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_legitimation.comment'
                      checked={form.natural_person_legitimation.comment}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('Politisch exponierte Person (PEP)')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_legitimation.pep'
                      checked={form.natural_person_legitimation.pep}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('ausweisnummer')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_legitimation.id_number'
                      checked={form.natural_person_legitimation.id_number}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('gültigBis')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_legitimation.valid_to'
                      checked={form.natural_person_legitimation.valid_to}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('ausgestelltAm')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_legitimation.issued_on'
                      checked={form.natural_person_legitimation.issued_on}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('ausstellendeBehörde')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='natural_person_legitimation.issuing_authority'
                      checked={form.natural_person_legitimation.issuing_authority}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row className='mt-2'>
              <h5
                className='bg-collapse text-white p-2 rounded mb-3 cursor-pointer d-flex align-items-center'
                onClick={() => setAdressenOpen(!adressenOpen)}
              >
                <PersonVcardFill />
                &nbsp;{t('Adressen')}
                {<b className='ms-auto'>{adressenOpen ? '▼' : '►'}</b>}
              </h5>
            </Row>

            {adressenOpen && (
              <>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('gültigVon')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.valid_since'}
                      checked={form.address.valid_since}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('gültigBis')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.valid_to'}
                      checked={form.address.valid_to}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('adresszusatz')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.address_suffix'}
                      checked={form.address.address_suffix}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('adressart')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'address.type'} checked={true} disabled />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('street')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'address.street'} checked={true} disabled />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('postfachadresse')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.post_office_box'}
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('PLZ')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'address.zip_code'} checked={true} disabled />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('place')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'address.city'} checked={true} disabled />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('country')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.country'}
                      checked={form.address.country}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('versandzusatz')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.shipping_supplement'}
                      checked={form.address.shipping_supplement}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('Notiz')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'address.note'}
                      checked={form.address.note}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row className='mt-2'>
              <h5
                className='bg-collapse text-white p-2 rounded mb-3 cursor-pointer d-flex align-items-center'
                onClick={() => setKommunikationOpen(!kommunikationOpen)}
              >
                <Globe2 />
                &nbsp;{t('Kommunikation')}
                <b className='ms-auto'>{kommunikationOpen ? '▼' : '►'}</b>
              </h5>
            </Row>

            {kommunikationOpen && (
              <>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('Telefon')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'communication.phone'}
                      checked={form.communication.phone}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('Email')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'communication.email'}
                      checked={form.communication.email}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('URL')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'communication.url'}
                      checked={form.communication.url}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row className='mt-2'>
              <h5
                className='bg-collapse text-white p-2 rounded mb-3 cursor-pointer d-flex align-items-center'
                onClick={() => setBankenOpen(!bankenOpen)}
              >
                <CreditCardFill />
                &nbsp;{t('Banken')}
                <b className='ms-auto'>{bankenOpen ? '▼' : '►'}</b>
              </h5>
            </Row>

            {bankenOpen && (
              <>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('gültigVon')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'bank.valid_since'}
                      checked={form.bank.valid_since}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('gültigBis')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'bank.valid_to'}
                      checked={form.bank.valid_to}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('country')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'bank.country'} checked={true} disabled />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('bank')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'bank.bank'} checked={true} disabled />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('iban')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id={'bank.iban'} checked={true} disabled />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('kontonummer')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'bank.account_number'}
                      checked={form.bank.account_number}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('kontoinhaber')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id={'bank.account_holder'}
                      checked={form.bank.account_holder}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row className='mt-2'>
              <h5
                className='bg-collapse text-white p-2 rounded mb-3 cursor-pointer d-flex align-items-center'
                onClick={() => setBeziehungenOpen(!beziehungenOpen)}
              >
                <CreditCardFill />
                &nbsp;{t('Beziehungen')}
                <b className='ms-auto'>{beziehungenOpen ? '▼' : '►'}</b>
              </h5>
            </Row>

            {beziehungenOpen && (
              <>
                <Row className='mt-2'>
                  <Col xs={2}>
                    <label>
                      {t('hat')}/{t('ist')}
                    </label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id='beziehung.hatIst' checked={true} disabled />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('beziehung')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check type='checkbox' id='beziehung.name' checked={true} disabled />
                  </Col>
                </Row>

                <div className='bg-info-subtle p-2 rounded mb-3 mt-4 d-flex align-items-center'>
                  <InfoCircleFill className='me-2' />{' '}
                  <strong className='small'>{t('angabenZu')}</strong>
                </div>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('adressattype')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.addressee_type'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('anrede')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.anrede'
                      checked={form.beziehung.anrede}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('Unternehmensname')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.addressee_type'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('Unternehmensform')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.legal_person_info.legal_form'
                      checked={form.beziehung.legal_person_info?.legal_form}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('titelGrad')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.naturliche_person_info.academic_degree'
                      checked={form.beziehung.naturliche_person_info.academic_degree}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('vorname')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.naturliche_person_info.first_name'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('nachname')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.naturliche_person_info.name'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('dateOfBirth')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.naturliche_person_info.birth_date'
                      checked={form.beziehung.naturliche_person_info.birth_date}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('bundesland')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.naturliche_person_info.federal_state'
                      checked={form.beziehung.naturliche_person_info.federal_state}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('idNumber')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.naturliche_person_info.id_number'
                      checked={form.beziehung.naturliche_person_info.id_number}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <div className='bg-info-subtle p-2 rounded mb-3 mt-4 d-flex align-items-center'>
                  <InfoCircleFill className='me-2' />{' '}
                  <strong className='small'>{t('communicationAndAddress')}</strong>
                </div>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('adressart')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.type'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('street')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.street'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('postfachadresse')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.street'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('plz')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.zip_code'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('place')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.city'
                      checked={true}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('country')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.country'
                      checked={form.beziehung.address.country}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4'>
                  <Col xs={2}>
                    <label>{t('phone')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.phone'
                      checked={form.beziehung.address.phone}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>

                <Row className='mt-4 mb-3'>
                  <Col xs={2}>
                    <label>{t('email')}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Check
                      type='checkbox'
                      id='beziehung.address.email'
                      checked={form.beziehung.address.email}
                      onChange={changeLocal}
                    />
                  </Col>
                </Row>
              </>
            )}
          </main>
        </Row>
      </Container>
    </>
  )
}
